export const DEFAULT_LOGIN_LOGO_SRC = '/assets/images/logos/lender_icon.svg';
export const DEFAULT_LOGIN_LOGO_ALT = 'Logo';
